export const NOTIFICATION_ACTIONS = {
  READ: 'read',
  UNREAD: 'unread',
  DELETE: 'delete',
};

export const NOTIFICATION_UPDATE_INTERVAL = 120000; // 2 mins

export const NOTIFICATION_BULK_UPLOAD_ORIGINS = ['EntityBulkImport', 'MasterSetupEntityBulkImport'];

export const NOTIFICATION_APP_MIGRATION = ['Import'];

export const TOAST_TYPE = {
  AI: 'ai',
  INFO: 'info',
};

export const TOAST_VARIANT = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export const DEFAULT_TOAST_TYPE = TOAST_TYPE.INFO;
export const DEFAULT_TOAST_VARIANT = TOAST_VARIANT.INFO;
